import "./MenuItem.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export default function MenuItem({
  id,
  isCombo = false,
  product,
  isActive,
  showTooltip,
  setShowTooltip,
  cart,
  setCart,
  setShowMessage,
}) {
  const { categoryId } = useParams();
  let navigate = useNavigate();
  const { t } = useTranslation();

  const [priceBGN, setPriceBGN] = useState(null);

  useEffect(() => {
    if (!product?.price) return;

    setPriceBGN((Number(product?.price) * 1.95583).toFixed(2));
  }, [product]);
  return (
    <div className="single-item">
      <div
        className="item-image"
        onClick={() => {
          isCombo
            ? (window.location.href = `/menu/category/${categoryId}/subcategory/combos/product/${product?.id}`)
            : (window.location.href = `/menu/category/${categoryId}/product/${product?.id}`);
        }}
      >
        {product?.images[0]?.url ? (
          <img src={product?.images[0]?.url} alt={product?.name} />
        ) : (
          <img
            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
            alt={product?.name}
          />
        )}
      </div>
      <div
        className="title"
        onClick={() => {
          isCombo
            ? (window.location.href = `/menu/category/${categoryId}/subcategory/combos/product/${product?.id}`)
            : (window.location.href = `/menu/category/${categoryId}/product/${product?.id}`);
        }}
      >
        <p>
          {product?.name}
          <span> {product?.weight && `${product?.weight}г`}</span>
        </p>
      </div>
      {product?.promoPrice === null || isCombo ? (
        <div className="price">
          <p>
            {Number(product?.price).toFixed(2)} {"€/"}
            {priceBGN !== null ? priceBGN + t("lv") : "Converting..."}
          </p>
        </div>
      ) : (
        <div className="price">
          <p className="new">
            {Number(product?.promoPrice).toFixed(2)} {"€/"}
          </p>
          <p className="old">
            {Number(product?.price).toFixed(2)} {"€/"}
          </p>
        </div>
      )}
      <div className={`add-to-cart ${!isActive ? "disabled" : ""}`}>
        {!isActive && (
          <p className={`${showTooltip ? "visible" : ""} sushi-available`}>
            {t("sushi-available")}
          </p>
        )}
        <button
          disabled={!isActive}
          onMouseOver={() => !isActive && setShowTooltip(true)}
          onMouseLeave={() => !isActive && setShowTooltip(false)}
          onClick={() => {
            if (typeof window.gtag === "function") {
              window.gtag("event", "add_to_cart", {
                currency: "EUR",
                value: product?.price,
                items: [product],
              });
            } else {
              console.error("gtag is not defined!");
            }
            setShowMessage(true);
            if (id !== "combos") {
              let existing = false;
              cart.map((item) => {
                if (item.id === product.id) {
                  existing = true;
                }
              });
              if (existing) {
                setCart((currentCart) =>
                  currentCart.map((item) =>
                    item.id === product.id
                      ? { ...item, amount: item.amount + 1 }
                      : item,
                  ),
                );
              } else {
                setCart([
                  ...cart,
                  {
                    ...product,
                    added: [],
                    removed: [],
                    amount: 1,
                    price: product?.price,
                    singlePrice: product?.price,
                    isCombo: false,
                  },
                ]);
              }
            } else {
              let existing = false;
              cart.map((item) => {
                if (item.id === product.id) {
                  existing = true;
                }
              });
              if (existing) {
                setCart((currentCart) =>
                  currentCart.map((item) =>
                    item.id === product.id
                      ? { ...item, amount: item.amount + 1 }
                      : item,
                  ),
                );
              } else {
                setCart([
                  ...cart,
                  {
                    ...product,
                    amount: 1,
                    price: product?.price,
                    singlePrice: product?.price,
                    isCombo: true,
                  },
                ]);
              }
            }
          }}
        >
          {t("add")}
        </button>
      </div>
    </div>
  );
}
